import { Location } from '@angular/common';
import { ApplicationRef, Component, NgZone, inject } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';

import { EnvironmentConfig } from '@frontend/oxygen/bma-env-config';
import { PubSubService } from '@frontend/oxygen/core';
import decorateTick from '@frontend/oxygen/core-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'root-app',
    templateUrl: './app.component.html',
    standalone: false,
})
export class RootComponent {
    private readonly environment = inject(EnvironmentConfig).configuration;
    isProduction = this.environment.PRODUCTION;
    protected routeChangeListener: Subscription;

    constructor(
        private applicationRef: ApplicationRef,
        private ngZone: NgZone,
        private pubSubService: PubSubService,
        private router: Router,
        private location: Location,
    ) {
        decorateTick(this.applicationRef, this.ngZone, this.pubSubService, this.router);
    }

    ngOnInit(): void {
        this.routeChangeListener = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart || event instanceof NavigationEnd) {
                if (!this.checkForSameDomain(event.url) && !event.url.includes('en/sports') && !event.url.includes('http')) {
                    this.router.navigate([`/en/sports${event.url}`]);
                } else if (this.location.path().includes('en/sports/bet-filter') && !this.router.url.includes('en/sports/bet-filter')) {
                    this.location.replaceState(this.router.url);
                }
            }
        });
    }

    /**
     * Check if part of url contains other domains or not
     * @param url
     * @param paths
     * @returns booelan
     */
    urlMatchesAnyPath(url: string, paths: string[]): boolean {
        return paths.some((path) => url.startsWith(path));
    }

    /**
     * Check if current navigation falls under same domain host
     * @param url
     * @returns boolean
     */
    private checkForSameDomain(url: string) {
        const OTHER_DOMAINS_CONFIG_FALLBACK = ['/en/games', '/en/livecasino', '/en/promo/offers', '/en/bingo', '/en/mobileportal'];
        const OTHER_DOMAINS = this.environment.OTHER_DOMAINS_CONFIG || OTHER_DOMAINS_CONFIG_FALLBACK;
        return this.urlMatchesAnyPath(url, OTHER_DOMAINS);
    }

    ngOnDestroy(): void {
        this.routeChangeListener && this.routeChangeListener.unsubscribe();
    }
}
